//import http from "../http";

const notifiesService = {

        GetNotifications: async () => {
            //const Notifications = await http.instance.get("/Notify");
            return [];
        }

};

export default notifiesService;
